import { FontFamilyKind } from '../Model/FontFamilyKind';
var Templater = /** @class */ (function () {
    function Templater() {
    }
    Templater.parse = function (view, params) {
        view = Templater.parseEach(view, params);
        view = Templater.parseIf(view, params);
        view = Templater.substitute(view, params);
        return view;
    };
    Templater.createFontLink = function (font, baseUrl) {
        if ([FontFamilyKind.Arial, FontFamilyKind.FranklinGothicDemi].indexOf(font.kind) > -1) {
            return null;
        }
        var fontLink = document.createElement('link');
        fontLink.setAttribute('type', 'text/css');
        fontLink.setAttribute('rel', 'stylesheet');
        fontLink.setAttribute('href', baseUrl + '/gfonts/css?family='
            + font.name.replace(/ /g, '+')
            + ':300,400,600,700&subset=cyrillic-ext,latin');
        return fontLink;
    };
    Templater.sanitizeCssVar = function (value) {
        if (this.sanitize(value, []) === value && value.indexOf(';') === -1) {
            return value;
        }
        return '';
    };
    Templater.parseEach = function (view, params) {
        if (params === void 0) { params = {}; }
        view = view.replace(/{{each (\w+) as (\w+)}}([\s\S]*?){{\/each}}/g, function (substring, key, value, body) {
            var result = [];
            if (params[key]) {
                for (var i in params[key]) {
                    if (params[key].hasOwnProperty(i)) {
                        var oldValue = params[value];
                        params[value] = params[key][i];
                        result.push(Templater.parse(body, params));
                        params[value] = oldValue;
                    }
                }
            }
            return result.join('');
        });
        return view;
    };
    Templater.parseIf = function (view, params) {
        if (params === void 0) { params = {}; }
        view = view.replace(/{{if ([\w\.]+)}}([\s\S]*?){{\/if}}/g, function (substring, key, body) {
            if (Templater.traverse(key, params)) {
                return body;
            }
            return '';
        });
        return view;
    };
    Templater.traverse = function (key, params) {
        if (params === void 0) { params = {}; }
        var parts = key.split('.');
        var currentValue = undefined;
        for (var part in parts) {
            if (parts.hasOwnProperty(part)) {
                if (currentValue !== undefined) {
                    currentValue = currentValue[parts[part]];
                }
                else {
                    currentValue = params[parts[part]];
                }
            }
        }
        return currentValue;
    };
    Templater.substitute = function (view, params) {
        if (params === void 0) { params = {}; }
        view = view.replace(/{{([^}]+)}}/g, function (substring, key) {
            return Templater.sanitize(Templater.traverse(key, params), ['b', 'strong', 'i', 'em', 'u']);
        });
        return view;
    };
    Templater.sanitize = function (input, whitelist) {
        return (input || '').replace(/(<\/?([^>]+)>)/ig, function (substring, key, body) {
            return whitelist.indexOf(body) !== -1 ? substring : '';
        });
    };
    return Templater;
}());
export { Templater };
